import Svg, { ClipPath, G, Path } from "react-native-svg";
import { GetProps } from "tamagui";

const WeightScaleOutline = ({ color, ...props }: GetProps<typeof Svg>) => (
  <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <G clipPath="url(#a)">
      <Path
        stroke={color}
        strokeLinecap="round"
        strokeWidth={1.5}
        d="m12 8.383 1.514-2.5M4.791 23H19.21c.498 0 .922-.36.997-.849l2.782-18.009a.974.974 0 0 0-.582-1.05 26.934 26.934 0 0 0-20.812 0 .974.974 0 0 0-.582 1.05l2.782 18.01c.075.488.499.848.997.848Zm2.386-3.117h9.646c.498 0 .922-.36.998-.849l1.067-6.911a1.003 1.003 0 0 0-.998-1.151H6.11c-.619 0-1.092.545-.998 1.15l1.067 6.912c.076.488.5.849.998.849ZM5.343 4.747a19.908 19.908 0 0 1 13.314 0 .611.611 0 0 1 .409.575v2.06c0 .553-.452 1-1.01 1H5.944c-.557 0-1.009-.447-1.009-1v-2.06c0-.258.164-.488.409-.575Z"
      />
    </G>
    <ClipPath id="a">
      <Path fill="#fff" d="M0 0h24v24H0z" />
    </ClipPath>
  </Svg>
);
export default WeightScaleOutline;
